module.exports = __webpack_public_path__ + "img/sort-numeric-up.419f91c1.svg";